module.exports = __webpack_public_path__ + "img/hydraulic.03311c5d.webp";